__turbopack_context__.v({
  "body": "PrivacyPage-module-scss-module__5h3M1q__body",
  "bullet": "PrivacyPage-module-scss-module__5h3M1q__bullet",
  "bulletList": "PrivacyPage-module-scss-module__5h3M1q__bulletList",
  "chip": "PrivacyPage-module-scss-module__5h3M1q__chip",
  "chipIcon": "PrivacyPage-module-scss-module__5h3M1q__chipIcon",
  "content": "PrivacyPage-module-scss-module__5h3M1q__content",
  "header": "PrivacyPage-module-scss-module__5h3M1q__header",
  "inlineLink": "PrivacyPage-module-scss-module__5h3M1q__inlineLink",
  "lastUpdated": "PrivacyPage-module-scss-module__5h3M1q__lastUpdated",
  "lead": "PrivacyPage-module-scss-module__5h3M1q__lead",
  "orbs": "PrivacyPage-module-scss-module__5h3M1q__orbs",
  "privacyDrift": "PrivacyPage-module-scss-module__5h3M1q__privacyDrift",
  "privacyDriftAlt": "PrivacyPage-module-scss-module__5h3M1q__privacyDriftAlt",
  "section": "PrivacyPage-module-scss-module__5h3M1q__section",
  "sectionBody": "PrivacyPage-module-scss-module__5h3M1q__sectionBody",
  "sectionHeader": "PrivacyPage-module-scss-module__5h3M1q__sectionHeader",
  "sectionIndex": "PrivacyPage-module-scss-module__5h3M1q__sectionIndex",
  "sectionTitle": "PrivacyPage-module-scss-module__5h3M1q__sectionTitle",
  "shell": "PrivacyPage-module-scss-module__5h3M1q__shell",
  "summaryBody": "PrivacyPage-module-scss-module__5h3M1q__summaryBody",
  "summaryCard": "PrivacyPage-module-scss-module__5h3M1q__summaryCard",
  "summaryEyebrow": "PrivacyPage-module-scss-module__5h3M1q__summaryEyebrow",
  "summaryGrid": "PrivacyPage-module-scss-module__5h3M1q__summaryGrid",
  "title": "PrivacyPage-module-scss-module__5h3M1q__title",
  "toc": "PrivacyPage-module-scss-module__5h3M1q__toc",
  "tocIndex": "PrivacyPage-module-scss-module__5h3M1q__tocIndex",
  "tocLink": "PrivacyPage-module-scss-module__5h3M1q__tocLink",
  "tocList": "PrivacyPage-module-scss-module__5h3M1q__tocList",
  "tocTitle": "PrivacyPage-module-scss-module__5h3M1q__tocTitle",
});
